<template>
  <div class="home-body">
    <div class="wrap-blue banner-with-copy">
      <div class="row">
        <div class="col-xs-12 col-md-push-6 col-md-6 pic">
          <picture title="">
            <!--[if IE 9]><video style="display: none;"><![endif]-->
            <source srcset="/static/img/advertise/banner2_400.jpg" media="(min-width: 501px) and (max-width: 800px)">
            <source srcset="/static/img/advertise/banner2_600.jpg" media="(min-width: 801px) and (max-width: 1200px)">
            <source srcset="/static/img/advertise/banner2_800.jpg" media="(min-width: 1201px) and (max-width: 1600px)">
            <source srcset="/static/img/advertise/banner2_1000.jpg" media="(min-width: 1601px)">
            <!--[if IE 9]></video><![endif]-->
            <img src="/static/img/advertise/banner2_800.jpg" alt="">
          </picture>
          <div class="overlay"></div>
        </div>
        <div class="col-xs-12 col-md-pull-6 col-md-6 banner-content-wrap">
          <div class="banner-copy">
            <h1>Become <br />A Partner</h1>
            <p>
              Part of our mission is bringing people together who love to learn! Come be a part of it and see what CLEX advertising has to offer. We can serve your brand’s ads either directly on our secure platform or from your preferred third-party provider (Google, Bing, etc.).
            </p>
            <router-link class="btn-pub btn-pub-blank xs-full-width" :to="{name: 'contact-us'}">Become A Partner Today</router-link>
          </div>
        </div>

      </div>
    </div>

    <div class="ptb-100 text-center ad-content">
      <div class="inner">
        <p>
          <h2 class="xs-mb-50">As Seen On...</h2>
        </p>
        <div class="row xs-mb-50">
          <div class="col-xs-12 col-sm-3 xs-p-10">
            <img src="/static/img/advertise/google.png" alt="Google" title="Google" style="width:100%;" />
          </div>
          <div class="col-xs-12 col-sm-3 xs-p-10">
            <img src="/static/img/advertise/bing.gif" alt="Bing" title="Bing" style="width:100%;" />
          </div>
          <div class="col-xs-12 col-sm-3 xs-p-10">
            <img src="/static/img/advertise/Taboola.png" alt="Taboola" title="Taboola" style="width:100%;" />
          </div>
          <div class="col-xs-12 col-sm-3 xs-p-10">
            <img src="/static/img/advertise/Yahoo.png" alt="Yahoo" title="Yahoo" style="width:100%;" />
          </div>
        </div>
        <p class="xs-mb-50 large-text">We can achieve much more when we learn together. Become part of our team as an Advertising Partner.</p>
        <router-link class="btn-pub btn-pub-border-primary" :to="{name: 'contact-us'}">Become A Partner Today</router-link>
        <div class="row xs-pt-50">
          <div class="col-xs-12">
            <HorizontalAd :containerClass="''"></HorizontalAd>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>


<script>
  import _ from 'underscore'
  import InnerBanner from '../shared/controls/InnerBanner'
import { mapState, mapActions, mapGetters, mapMutations } from 'vuex'
  import HorizontalAd from '../shared/ads/HorizontalAd'
  import VerticalAd from '../shared/ads/VerticalAd'

export default {
    components: {
      InnerBanner,
      HorizontalAd,
      VerticalAd
  },
}
</script>


<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>
  .home-body { background: #FFFFFF; }
  .ad-content .inner { max-width: 750px; margin:0px auto;}
  .banner-with-copy .btn-pub { padding:0px 25px; }

  @media only screen and (max-width:1600px) {
    .banner-with-copy .banner-copy {padding:5%;}
  }
  @media only screen and (max-width:1200px) {
    .banner-with-copy .banner-copy { padding: 3% 5% 0px 5%; }
    .banner-with-copy h1 { font-size: 34px; }
    .banner-with-copy p { font-size: 20px; line-height: 24px; margin: 30px 0px; }
    .banner-with-copy .btn-pub { font-size: 20px; }
  }
  @media only screen and (max-width:767px) {
    .ad-content .inner { padding: 0px 0px 0px 0px; }
    .ad-content .ad-block {display:none;}

    .banner-with-copy .banner-copy { padding: 2% 3%; }

    .banner-with-copy h1 { font-size: 28px; }
    .banner-with-copy p { font-size: 15px; line-height: 18px; margin: 20px 0px; }
  }
  @media only screen and (max-width:500px) {
    .ad-content {padding:50px 20px;}
    .banner-with-copy p { font-size: 15px; line-height: 18px; margin: 20px 0px; }
  }
</style>



// WEBPACK FOOTER //
// AdvertisePage.vue?a2d9fc02